import { localStorage } from '@change-corgi/core/storage';

import type { Schema } from '../../shared/schema';
import { schema } from '../../shared/schema';

export function getDraftFromLocalStorage(id: string | null): Schema | null {
	if (!id) return null;

	const localDraft = localStorage.getItem(`draft-${id}`);
	const result = schema.safeParse(localDraft);

	return result.success ? result.data : null;
}
